import { useState } from 'react';

import { useAccountSelector } from 'src/hooks';
import { MFormSection } from 'src/lib';
import { AccountHolder } from 'src/models';

import { MailingAddressForm } from './MailingAddressForm';
import { MailingAddressView } from './MailingAddressView';

interface OtherAccountHolderMailingAddressSectionProps {
  accountHolder: AccountHolder;
}

export const OtherAccountHolderMailingAddressSection = ({
  accountHolder,
}: OtherAccountHolderMailingAddressSectionProps) => {
  const [isEditMode, setIsEditMode] = useState<boolean>(false);

  const { account } = useAccountSelector();

  const onEdit = () => {
    setIsEditMode(true);
  };

  const onCancel = () => {
    setIsEditMode(false);
  };

  return (
    <MFormSection title='Mailing Address' onEdit={onEdit} isEditable isEditMode={isEditMode} testId={'mailing-address'}>
      {!isEditMode ? (
        <MailingAddressView isPrimary={false} type={account?.type} accountHolder={accountHolder} testId='other' />
      ) : (
        <MailingAddressForm
          accountHolder={accountHolder}
          accountUuid={account?.id}
          isPrimary={false}
          onCancel={onCancel}
        />
      )}
    </MFormSection>
  );
};
